import React from 'react';
import { MenuItem } from './menuItem';
import styles from './menu.css';
var Menu = function (_a) {
    var activeIndex = _a.activeIndex, options = _a.options, onMouseDown = _a.onMouseDown, onKeyDown = _a.onKeyDown;
    return (React.createElement("ul", { "data-testid": "input-options", className: styles.Menu }, options.map(function (option, index) { return (React.createElement(MenuItem, { active: index === activeIndex, key: option.id, option: option, onMouseDown: onMouseDown, onKeyDown: onKeyDown })); })));
};
export { Menu };
